export default __webpack_public_path__ + "static/media/M_wdt_c_cap_6.87b51b8f.mp3";